import React from "react";
import { Form } from "../../../../primary";
import { FormActions } from "../../../../secondary";
import { ConfigForm } from "../../../../common/ConfigForm/ConfigForm";
import { NE1_SECTIONS, NE1_CUSTOM_VALIDATORS } from "../ne1.config";
import { Ne1StatusHeader } from "./Ne1StatusHeader";
import { CANCEL_BTN, SAVE_BTN } from "../../../../../constants";
import { PERMISSIONS } from "../../../../../constants/permissions";
import formStyle from "../../../../common/ConfigForm/ConfigForm.module.scss";
import styles from "../Ne1.module.scss";

export const Ne1EditMode = ({
  customerData,
  handleSubmit,
  doSubmit,
  register,
  errors,
  form,
  submitErrors,
  onFieldChange,
  onMultiChange,
  ne1State,
  popupSave,
  makeShiftSold,
  showConfirmPopup,
  onClickStatus,
  onModalOpen,
  onModalClose,
  onSavePopup,
  onCancelPopup,
  onCancel,
  saveLoading,
}) => (
  <div className={formStyle.form_container}>
    <Form onSubmit={handleSubmit(doSubmit)} requiredPermission={PERMISSIONS.ADMIN_CUSTOMERS}>
      <Ne1StatusHeader
        customerData={customerData}
        ne1State={ne1State}
        popupSave={popupSave}
        makeShiftSold={makeShiftSold}
        showConfirmPopup={showConfirmPopup}
        onClickStatus={onClickStatus}
        onModalOpen={onModalOpen}
        onModalClose={onModalClose}
        onSavePopup={onSavePopup}
        onCancelPopup={onCancelPopup}
      />

      <div className={styles.columns}>
        <div className={styles.column}>
          <ConfigForm
            sections={NE1_SECTIONS}
            column="left"
            form={form}
            errors={errors}
            submitErrors={submitErrors}
            onFieldChange={onFieldChange}
            onMultiChange={onMultiChange}
            register={register}
            customValidators={NE1_CUSTOM_VALIDATORS}
          />
        </div>
        <div className={styles.column}>
          <ConfigForm
            sections={NE1_SECTIONS}
            column="right"
            form={form}
            errors={errors}
            submitErrors={submitErrors}
            onFieldChange={onFieldChange}
            onMultiChange={onMultiChange}
            register={register}
            customValidators={NE1_CUSTOM_VALIDATORS}
          />
        </div>
      </div>

      <FormActions
        primaryLabel={SAVE_BTN}
        primaryId="updateBtn"
        primaryType="submit"
        primaryLoading={saveLoading}
        secondaryLabel={CANCEL_BTN}
        secondaryId="cancelBtn"
        secondaryDisabled={saveLoading}
        onSecondaryClick={onCancel}
      />
    </Form>
  </div>
);
